export default "__VITE_ASSET__BapR$nKP__"